import {Link, useLocation, useNavigate, useSearchParams} from "react-router-dom";
import React, {useEffect, useRef, useState} from "react";
import {useUser} from "../../../contexts/UserContext";
import {useModal} from "../../../contexts/ModalContext";
import AxiosConfig from "../../../services/AxiosConfig";
import styles from "../../../pages/Admin/Admin.module.css";
import {faCopy,  faExternalLink} from "@fortawesome/free-solid-svg-icons";
import FilterHamburgerCustom from "../../Filter/FilterHamburgerCustom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import UtilisateursTable from "./UtilisateursTable";
import {
    fetchToSetUtilisateurActif, getUtilisateurRoleIcon, getUtilisateurStatus,
    getUtilisateurStatusIcon, USER_STATUS_VALUE
} from "../../../services/UserService";
import TitleSecondary from "../../Title/TitleSecondary";
import { ReactComponent as AjouterIcone } from '../../../icons/ajouter.svg';
import SearchEntreprise from "../../Search/SearchEntreprise";
import {copyToClipboard} from "../../../services/UtilsService";
import styles_filter from "../../Filter/Filter.module.css";
import {updateFilterUri} from "../../../services/FilterService";
import {ReactComponent as AnnulerIcone} from "../../../icons/annuler.svg";
import styles_field from "../../Field/Field.module.css";
import Routing from "../../../services/routing";
import PaginationBar from "../../Pagination/PaginationBar";
import SearchUtilisateur from "../../Search/SearchUtilisateur";
import {isAdmin} from "../../../services/RoleService";

function UtilisateursVue({ idEnt = null }) {
    const {user} = useUser();
    const {showModal, hideModal} = useModal();
    const [myApiData, setMyApiData] = useState([]);
    const [actif, setActif] = useState(true);
    const [entrepriseId, setEntrepriseId] = useState(null);
    const [status, setStatus] = useState(USER_STATUS_VALUE);
    const navigate = useNavigate();
    const location = useLocation();
    const [filters, setFilters] = useState({});
    const [lienEnrolement, setLienEnrolement] = useState(null);
    const params = new URLSearchParams(location.search);
    const [filterSeanceDateDebut, setFilterSeanceDateDebut] = useState('');
    const [filterSeanceDateFin, setFilterSeanceDateFin] = useState('');
    const [page, setPage] = useState(1);
    const [totalPage, setTotalPage] = useState(null);
    const [totalResult, setTotalResult] = useState(null);
    const [sortBy, setSortBy] = useState([]);
    const prevSortBy = useRef(sortBy);
    const [utilisateur, setUtilisateur] = useState(null);
    let url = "/admin/utilisateurs";

    const handleSuccess = (children = "Note enregistrée avec succès") => {
        showModal('success', {children: children, timeout: 1500});
    };

    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 1500});
    };

    const handleConfirmationDateDebutChange = (event) => {
        setFilterSeanceDateDebut(event.target.value);
    };

    const handleConfirmationDateFinChange = (event) => {
        setFilterSeanceDateFin(event.target.value);
    };

    const applyDateSeanceFilter = () => {
        const dateFilterValue = `${filterSeanceDateDebut},${filterSeanceDateFin}`;
        updateFilter('filter_seance_date', dateFilterValue, true);
    };

    const getUtilisateurs = async (filters) => {
        if (idEnt) {
            filters = {
                ...filters,
                entrepriseId: idEnt,
            }

        }

        if (filters) {
            let cpt = 0;
            for (const [key, value] of Object.entries(filters)) {
                if (value) {
                    if (cpt === 0) {
                        url += `?filter_${key}=${value}`;
                    } else {
                        url += `&filter_${key}=${value}`;
                    }
                    cpt++;
                }
            }
        }

        try {
            const response = await AxiosConfig.get(url);
            setMyApiData(response.data.myUtilisateurs);
            setTotalPage(response.data.totalPages);
            setTotalResult(response.data.totalResults);

            // response.data.myUtilisateurs.map((user) => {
            //     if (user.status && !status.includes(user.status)) {
            //         status.push(user.status);
            //     }
            // });
        } catch (error) {
            console.error('error', error);
            handleError("Erreur lors de la récupération des utilisateurs: "+error);
        }
    }

    const putActifOpenModal = (utilisateur) => {
        const text = utilisateur.actif ? "supprimer" :  "activer";
        showModal('confirm', {
            message: `Voulez-vous vraiment ${text} cet utilisateur ?`,
            onConfirm: async () => {
                if (utilisateur.id === user.id) {
                    handleError("Vous ne devriez pas désactiver votre propre compte");
                    return;
                }
                const response = await fetchToSetUtilisateurActif(utilisateur);
                if (response.success) {
                    handleSuccess(response.message);
                } else {
                    handleError(response.message);
                }
                setTimeout(() => {
                    getUtilisateurs(filters);
                }, 500);
            }
        });
    }

    const handleSendInviteCreateAccountMassive = async (entrepriseId) => {
        if (!entrepriseId) return handleError("Veuillez sélectionner une entreprise");

        try {
            const response = await AxiosConfig.get(Routing.generate({ route: Routing.routesApi.adminEntrepriseSendInviteCreateAccountMassive, params: {entrepriseId} }));
            const nbUsers = response.data.utilisateurs.length;
            handleSuccess("Envoi réussi : "+nbUsers+" utilisateurs invités");
        } catch (error) {
            console.error('error', error);
            handleError("Erreur lors de l'envoi");
        }
    }

    const handleSendInviteCreateAccountUnit = async (entrepriseId) => {
        if (!entrepriseId) return handleError("Veuillez sélectionner une entreprise");

        try {
            const response = await AxiosConfig.get(Routing.generate({ route: Routing.routesApi.adminEntrepriseSendInviteCreateAccountUnit, params: {entrepriseId} }));
            handleSuccess("Envoi réussi");
        } catch (error) {
            console.error('error', error);
            handleError("Erreur lors de l'envoi");
        }
    }

    const handleGenerateLienEnrolement = async (entrepriseId) => {
        if (!entrepriseId) return handleError("Veuillez sélectionner une entreprise");
        try {
            const response = await AxiosConfig.get(Routing.generate({ route: Routing.routesApi.adminEntrepriseEnrolement, params: {entrepriseId} }));
            return response;
        } catch (error) {
            console.error('error', error);
            handleError("Erreur lors de l'envoi");
        }
    }

    const removeFilter = (e) => {
        const key = e.currentTarget.querySelector('.filter_key').textContent;
        params.delete(`filter_${key}`);
        navigate(`?${params.toString()}`);
    }

    const updateFilter = (filterKey, filterValue, resetFilter = false) => {
        const params = new URLSearchParams(location.search);

        updateFilterUri(params, filterKey, filterValue, resetFilter);

        navigate(`${location.pathname}?${params.toString()}`, { replace: true });
    };

    const childrenOfFilter = (
        <div style={{display: "flex", flexDirection: "column", gap: "10px", margin: "35px"}}>
            <TitleSecondary text="Filtres"/>

            <div className={styles_filter.filtersRemoveBar}>
                {/* Aficher tous les parametres de l'url commençant par filter_ */}
                {Array.from(params.entries())
                    .filter(([key, value]) => key.startsWith('filter_'))
                    .map(([key, value]) => {
                        return (
                            <button key={key} className={styles_filter.btnFilterRemove} onClick={removeFilter}>
                                <AnnulerIcone/>
                                <span className={"filter_key"}>{key.replace('filter_', '')}</span> : {value}
                            </button>
                        );
                    })
                }
            </div>

            <div style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
            }}>
                {(isAdmin(user) && !idEnt) && <div><p>Entreprise</p><SearchEntreprise onSubmit={(entr) => {
                    updateFilter('filter_entrepriseId', entr.entrepriseId, true);
                }}/></div>}

                <div className={styles_field.field}>
                    <span>Utilisateur</span>
                    <SearchUtilisateur onSubmit={(u) => {
                        updateFilter('filter_user', u.id, true);
                    }}/>
                </div>


                <div>
                    <span>Civilité</span>
                    <div style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "8px",
                        padding: "8px",
                        outline: "1px solid var(--clr-accent)",
                    }}>
                        <button className={styles_filter.btnFiltre}
                                onClick={() => updateFilter('filter_civilite', '4', true)}>Homme
                        </button>
                        <button className={styles_filter.btnFiltre}
                                onClick={() => updateFilter('filter_civilite', '3', true)}>Femme
                        </button>
                    </div>
                </div>

                <div>
                    <span>Statut</span>
                    <div style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "8px",
                        padding: "8px",
                        outline: "1px solid var(--clr-accent)",
                    }}>
                        {
                            status && status.map((s, index) => {
                                return <button key={index} className={styles_filter.btnFiltre}
                                               onClick={() => updateFilter('filter_status', s, true)}>
                                    {getUtilisateurStatusIcon(s)} {getUtilisateurStatus(s)}
                                </button>
                            })}
                    </div>
                </div>

                <div>
                    <span>Role</span>
                    <div style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "8px",
                        padding: "8px",
                        outline: "1px solid var(--clr-accent)",
                    }}>
                        <button className={styles_filter.btnFiltre}
                                onClick={() => updateFilter('filter_role', "", true)}>
                            Tous
                        </button>

                        <button className={styles_filter.btnFiltre}
                                onClick={() => updateFilter('filter_role', "ROLE_USER", true)}>
                            {getUtilisateurRoleIcon("ROLE_USER")} Utilisateur
                        </button>

                        <button className={styles_filter.btnFiltre}
                                onClick={() => updateFilter('filter_role', "ROLE_COACH", true)}>
                            {getUtilisateurRoleIcon("ROLE_COACH")} Coach
                        </button>

                        <button className={styles_filter.btnFiltre}
                                onClick={() => updateFilter('filter_role', "ROLE_REFERENT", true)}>
                            {getUtilisateurRoleIcon("ROLE_REFERENT")} Référent
                        </button>

                        <button className={styles_filter.btnFiltre}
                                onClick={() => updateFilter('filter_role', "ROLE_ADMIN", true)}>
                            {getUtilisateurRoleIcon("ROLE_ADMIN")} Admin
                        </button>

                        <button className={styles_filter.btnFiltre}
                                onClick={() => updateFilter('filter_role', "ROLE_SUPER_ADMIN", true)}>
                            {getUtilisateurRoleIcon("ROLE_SUPER_ADMIN")} Super Admin
                        </button>
                    </div>
                </div>

                <div>
                    <span>Utilisateurs supprimés</span>
                    <div style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "8px",
                        padding: "8px",
                        outline: "1px solid var(--clr-accent)",
                    }}>
                        <button className={styles_filter.btnFiltre}
                                onClick={() => updateFilter('filter_actif', 'false', true)}>
                            Oui
                        </button>

                        <button className={styles_filter.btnFiltre}
                                onClick={() => updateFilter('filter_actif', 'true', true)}>
                            Non
                        </button>
                    </div>
                </div>

                <div>
                    <span>Participe à une séance entre</span>
                    <div style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "8px",
                        padding: "8px",
                        outline: "1px solid var(--clr-accent)",
                    }}>
                        <div>
                            <span>De </span>
                            <input
                                type="date"
                                value={filterSeanceDateDebut}
                                onChange={handleConfirmationDateDebutChange}
                                className={styles_field.inputy}
                            />

                            <span> à </span>
                            <input
                                type="date"
                                value={filterSeanceDateFin}
                                onChange={handleConfirmationDateFinChange}
                                className={styles_field.inputy}
                            />
                        </div>

                        <button onClick={applyDateSeanceFilter} className={"btn btn_success"}>Valider</button>
                    </div>
                </div>
            </div>
        </div>
    );

    const handleSubmitUtilisateurStatus = async (values, {setSubmitting}) => {

        try {
            const response = await AxiosConfig.post(Routing.generate({ route: Routing.routesApi.adminUtilisateursSetStatus, params: { utilisateurId: values.id } }), values);

            if (response.data.success) {
                handleSuccess(response.data.message);
                getUtilisateurs(filters);
            } else {
                console.error('error', response.data);
                handleError("Erreur : " + response.data.message);
            }
        } catch (error) {
            console.error('error', error);
            handleError();
        }
    };

    const onSortChange = ({ sortBy }) => {
        if (JSON.stringify(sortBy) !== JSON.stringify(prevSortBy.current)) {
            prevSortBy.current = sortBy;
            setSortBy(sortBy);
        }
    };

    const getInitialSortBy = () => {
        const sortBy = [];
        params.getAll('sort_by').forEach((id, index) => {
            sortBy.push({ id, desc: params.getAll('sort_desc')[index] === 'true' });
        });
        return sortBy;
    };


    useEffect(() => {
        if (!location.search) {
            getUtilisateurs();
            return;
        }

        const queryParams = new URLSearchParams(location.search);
        queryParams.forEach((value, key) => {
            setFilters({});
            const filterKey = key.replace('filter_', '');
            filters[filterKey] = value;
        });
        getUtilisateurs(filters);
    }, [location]);

    useEffect(() => {
        if (page) {
            params.set('page', page);
            navigate(`${location.pathname}?${params.toString()}`);
        }
    }, [page]);

    return (
        <>
            <div style={{display: "flex", flexDirection: "column", padding: "16px", gap: "10px", outline: "1px solid var(--clr-accent)", borderRadius: "12px" }}>

                <div>
                    <span style={{ marginLeft: "12px"}}>Sélectionner une entreprise</span>
                    <SearchEntreprise onSubmit={(e) => {
                        setEntrepriseId(e.entrepriseId)
                    }}/>
                </div>

                <div style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "16px",
                    justifyContent: "center",
                    alignItems: "center",
                }}>
                    {/* <button className={"btn"} onClick={async () => { await handleSendInviteCreateAccountMassive(entrepriseId) }}>Envoyer invitation confirmation de compte (masse)</button> */}
                    {/* <button className={"btn"} onClick={async () => { await handleSendInviteCreateAccountUnit(entrepriseId) }}>Envoyer invitation confirmation de compte (unitaire)</button> */}
                    <button className={"btn"} onClick={async () => {
                        const rez = await handleGenerateLienEnrolement(entrepriseId);
                        if (rez && rez.data && rez.data.success) {
                            setLienEnrolement(rez.data.lien);
                        } else {
                            console.error("Erreur lors de la génération du lien d'enrolement");
                            console.error(rez);
                        }
                    }}>Lien enrolement</button>
                </div>
                {lienEnrolement && (
                    <span
                        style={{ backgroundColor: "#e4fade", borderRadius: "10px", outline: "1px solid #000", fontStyle: "italic", fontSize: "0.85rem", padding: "14px", cursor: "copy" }}
                        onClick={() => copyToClipboard(lienEnrolement, handleSuccess)}
                    >
                        <FontAwesomeIcon icon={faCopy} style={{ marginRight: "8px" }} />
                      {lienEnrolement}
                    </span>
                )}
            </div>

            <div className={ styles.navLink }>
                <Link to={Routing.routes.adminCreation}>
                    <AjouterIcone />
                    Ajouter un utilisateur
                </Link>
                <Link to={Routing.routes.adminCreationEnMasseCsv}>
                    <AjouterIcone />
                    Création d'utilisateurs en masse
                </Link>

                <Link to={Routing.routes.adminCrmHistory}><FontAwesomeIcon icon={faExternalLink}/>CRM</Link>
                <Link to={Routing.routes.statsUsers}><FontAwesomeIcon icon={faExternalLink}/> Stats</Link>
            </div>

            <FilterHamburgerCustom onReinirFilters={
                () => {
                    const queryParams = new URLSearchParams(location.search);
                    Object.entries({
                        status: '',
                        seance_start: '',
                        seance_end: '',
                        civilite: '',
                        role: '',
                        actif: '',
                        entreprise: '',
                        entrepriseId: '',
                        user: '',
                    }).forEach(([key, value]) => {
                        if (value) {
                            queryParams.append(`filter_${key}`, value);
                        } else {
                            if (queryParams.has(`filter_${key}`)) {
                                queryParams.delete(`filter_${key}`);
                            }
                        }
                    });
                    navigate(`?${queryParams.toString()}`);
                }
            } children={childrenOfFilter} />

            {myApiData && <UtilisateursTable
                utilisateurs={myApiData}
                putActifOpenModal={putActifOpenModal}
                handleSubmitUtilisateurStatus={handleSubmitUtilisateurStatus}
                serverSideSorting={true}
                onSortChange={onSortChange}
                initialSortBy={getInitialSortBy()}
            />}
            <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                <PaginationBar page={page} totalPage={totalPage} setPage={setPage} totalResult={totalResult}/>
            </div>
        </>
    )
}

export default UtilisateursVue;